import React from 'react'
import { Image } from 'src/components/ui/Image'
import { useMobile } from 'src/hooks/useMobile'

import { StarterKitForm } from './StarterKitForm'
import { Modal } from '../restructure/product/utils/Modal'
import { useModalSheet } from '../contexts/ModalSheetContext'

interface StarterKitBannerProps {
  title: string
  imageDesktop: string
  imageMobile: string
}

const StarterKitBanner: React.FC<StarterKitBannerProps> = ({
  title,
  imageDesktop,
  imageMobile,
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const { isMobile } = useMobile()
  const { openModal, closeModal } = useModalSheet()

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleClick = () => {
    if (isMobile) {
      openModal({
        content: <StarterKitForm onClose={closeModal} />,
        width: '360px',
      })

      return
    }

    handleOpenModal()
  }

  return (
    <>
      <section className="w-full max-w-[1440px] mx-auto flex flex-col-reverse md:flex-row items-center justify-center">
        <button
          className="w-full flex justify-center items-center cursor-pointer"
          onClick={handleClick}
        >
          <Image
            src={imageDesktop}
            alt={title}
            className="hidden sm:block w-full h-full"
          />
          <Image
            src={imageMobile}
            alt={title}
            className="block sm:hidden w-full h-full"
          />
        </button>
      </section>
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <StarterKitForm onClose={handleCloseModal} />
      </Modal>
    </>
  )
}

export default StarterKitBanner
